import LandingPageLayout from './LandingPageLayout'
import NewLandingPageLayout from './NewLandingPage'
import GenAiLandingPageLayout from './GenAiLandingPage'

export { LandingPageLayout, NewLandingPageLayout, GenAiLandingPageLayout }
